import { designTokens } from "@itandi/itandi-bb-ui";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import { InputRadio } from "@itandi/itandi-bb-ui/InputRadio";
import { useContext, useState } from "react";
import { useDealConstructionItems } from "~/hooks/useDealConstructionItems";
import type { NskResponse } from "~/models/Api";
import type { DealConstructionEdit } from "~/models/DealConstruction";
import type { DealSettlementEdit } from "~/models/DealSettlement";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import { SettlementAddForm } from "../../settlements/adding/SettlementAddForm";
import { ConstructionAddForm } from "./ConstructionAddForm";
import Styles from "./InvoiceItemAddForm.module.scss";

type Props = {
	billingType: "owner" | "rentee";
	handleCreate: (
		submitValue: DealConstructionEdit | DealSettlementEdit
	) => Promise<NskResponse>;
	mutateConstructions: () => Promise<void>;
};
export function InvoiceItemAddForm({
	billingType,
	handleCreate,
	mutateConstructions
}: Props) {
	const [selectedOption, setSelectedOption] = useState("construction");
	const { company } = useContext(ItandiAccountContext);
	const settlementEnabled = company?.settlementEnabled ?? false;
	const { data: dealConstructionItems } = useDealConstructionItems();

	if (dealConstructionItems === null) {
		return null;
	}

	return (
		<div className={Styles.EstimateAddForm}>
			{settlementEnabled ? (
				<Box margin={designTokens["spacing/xs"]}>
					<FormGroup variant="vertical">
						<FormControl chip="必須" label="項目選択" variant="vertical">
							<Flex gap={designTokens["spacing/s"]}>
								<InputRadio
									checked={selectedOption === "construction"}
									label="施工項目"
									onChange={(): void => {
										setSelectedOption("construction");
									}}
									value="construction"
								/>
								<InputRadio
									checked={selectedOption === "settlement"}
									label="精算項目"
									onChange={(): void => {
										setSelectedOption("settlement");
									}}
									value="settlement"
								/>
							</Flex>
						</FormControl>
					</FormGroup>
				</Box>
			) : null}
			{selectedOption === "construction" ? (
				<ConstructionAddForm
					dealConstructionItems={dealConstructionItems}
					handleCreate={handleCreate}
					mutateConstructions={mutateConstructions}
				/>
			) : (
				<SettlementAddForm
					billingType={billingType}
					handleCreate={handleCreate}
					mutateConstructions={mutateConstructions}
				/>
			)}
		</div>
	);
}
